export default __webpack_public_path__ + "static/media/w5.d28b86d2.png";